/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".button-block[_ngcontent-%COMP%]{right:2px;bottom:55px;height:0}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/themes/default/css/my-tickets.component.less.shim.ngstyle.js.pre-build-optimizer.js